<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    title?: string;
    variant?: 'default' | 'accent' | 'p1' | 'p2' | 'positive' | 'danger' | 'muted';
    class?: string;
    children: Snippet;
  }

  let { title, variant = 'default', class: className = '', children }: Props = $props();
</script>

<section class="panel {variant === 'default' ? '' : `panel--${variant}`} {className}">
  {#if title}
    <h2 class="panel__title">{title}</h2>
  {/if}
  {@render children()}
</section>
